import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import BranchMenu from "@ignitesales/neuro-application/src/neuro-guide/components/BranchMenu";
import {ClientLogo} from "../../../../../../shared/js";

const Header = ({className}) => {
    const componentClass = 'header';
    const classes = classnames(
        'header',
        className
    );

    return <header className={classes}>
        <div className='container'>
            <div className={`${componentClass}__logo`}>
                <ClientLogo />
            </div>
            <BranchMenu />
        </div>
    </header>;
};

Header.propTypes = {
    className: PropTypes.string
};

export default Header;
